import { useState } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { IBandeiraCartao } from "../interface/IBandeiraCartao";

export const useBandeirasCartao = () => {
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();
    const apiPedidos = ApiFactory.getApi("MS_PEDIDOS");

    const criar = async (bandeira: IBandeiraCartao) => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.post('/bandeiras', bandeira);
            snackbar("Bandeira cadastrada com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao cadastrar a bandeira", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const atualizar = async (uuid: string, bandeira: IBandeiraCartao) => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.put(`/bandeiras/${uuid}`, bandeira);
            snackbar("Bandeira atualizada com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao atualizar a bandeira", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const deletar = async (uuid: string) => {
        setLoading(true);
        try {
            await apiPedidos.delete(`/bandeiras/${uuid}`);
            snackbar("Bandeira excluída com sucesso", { severity: "success" });
            return true;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao excluir a bandeira", { severity: "error" });
            return false;
        } finally {
            setLoading(false);
        }
    }

    /** Cadastra as bandeiras usuais do mercado, pulando as que já existem. */
    const adicionarPadroes = async () => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.post('/bandeiras/padroes');
            snackbar(data?.mensagem || "Bandeiras padrão adicionadas", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao adicionar as bandeiras padrão", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    return { criar, atualizar, deletar, adicionarPadroes, loading }
}
